import Leaderboard from './leaderboardComponent';
import Trending from './trendingComponent';
import SiteActivity from './siteActivityComponent';
import useExplorePageStyles from './useExplorePageStyles';
import HorizontalPad from './horizontalPad';
import VerticalPad from './verticalPad';
import useExplorePage from '../../../hooks/useExplorePage';
import GameParrot from '../gameParrot';
import LoadingScreen from '../../loadingScreen';

/**
 * ExplorePage component renders a page displaying a leaderboard, trending tab,
 * and site activity tab.
 * It is meant to expose the user to cumulative information about site usage.
 */
const ExplorePage = () => {
  const { classes } = useExplorePageStyles();
  const { users, questions, answers, rankingType, trendType } = useExplorePage();

  if (!users || !questions || !answers) {
    return <LoadingScreen />;
  }

  return (
    <>
      <div className={classes.pageContainer}>
        <HorizontalPad />
        <div className={classes.componentsContainer}>
          <VerticalPad />
          <div className={classes.leftContainer}>
            <Leaderboard
              users={users}
              questions={questions}
              answers={answers}
              rankingType={rankingType}
            />
          </div>
          <VerticalPad />
          <div className={classes.rightContainer}>
            <Trending users={users} questions={questions} answers={answers} trendType={trendType} />
            <HorizontalPad />
            <SiteActivity questions={questions} answers={answers} />
          </div>
          <VerticalPad />
        </div>
        <HorizontalPad />
      </div>
      <GameParrot />
    </>
  );
};

export default ExplorePage;
